<div [ngStyle]="style" [ngClass]="class" ><ng-content></ng-content></div>
